import { Controller } from '@hotwired/stimulus'
import { post } from '@rails/request.js'

export default class extends Controller<HTMLDivElement> {
  static targets: string[] = ['messages']
  declare readonly hasMessagesTarget: boolean

  connect(): void {
    this.setupNotifications()
  }

  disconnect(): void {
    this.removeListener()
  }

  get granted() {
    return Notification.permission === 'granted'
  }

  get denied() {
    return Notification.permission === 'denied'
  }

  get vapidPublicKey() {
    const element = document.querySelector(
      'meta[name="vapid-public-key"]'
    ) as HTMLMetaElement
    const array = JSON.parse(element.content)
    return new Uint8Array(array)
  }

  private async registerServiceWorker() {
    if ('serviceWorker' in navigator) {
      try {
        const registration = await navigator.serviceWorker.register(
          '/service-worker.js',
          {
            scope: '/',
          }
        )

        let subscription = await registration.pushManager.getSubscription()

        if (!subscription) {
          subscription = await registration.pushManager.subscribe({
            userVisibleOnly: true,
            applicationServerKey: this.vapidPublicKey,
          })
        }

        const json = subscription.toJSON()

        try {
          await post('/web-devices', {
            body: {
              device: {
                endpoint: json.endpoint,
                p256dh_key: json.keys?.p256dh,
                auth_key: json.keys?.auth,
              },
            },
          })
        } catch (error) {
          console.error(error)
        }

        // if ('SyncManager' in window) {
        //   registration.sync.register('sync-forms')
        // } else {
        //   window.alert('This browser does not support background sync.')
        // }
      } catch (error) {
        console.error(`Registration failed with ${error}`)
      }
    }
  }

  private setupNotifications = async () => {
    if (!('Notification' in window)) {
      return console.log('Notifications not supported')
    }

    if (this.denied) return

    if (this.granted) return this.registerServiceWorker()

    this.setupListener()
  }

  private requestPermission = async () => {
    const permission = await Notification.requestPermission()

    if (permission === 'granted') {
      this.registerServiceWorker()
      this.removeListener()
    }
  }

  private setupListener() {
    this.element.addEventListener('click', this.requestPermission)
  }

  private removeListener() {
    this.element.removeEventListener('click', this.requestPermission)
  }
}
